import React from 'react';
import { FormControlLabel, Switch, Tooltip } from '@mui/material';

import { useModifierKey } from '@paragon/client-tools';

interface InsertAutomaticallySwitchProps {
  readonly checked: boolean;
  readonly canInsert: boolean;
  readonly insertedObjectName: string;
  readonly onChange: (checked: boolean) => void;
  readonly onInsert: () => Promise<void>;
}

export function InsertAutomaticallySwitch(props: InsertAutomaticallySwitchProps) {
  const altHeld = useModifierKey('altKey');

  return (
    <Tooltip
      title={`Insert as soon as the ${props.insertedObjectName} is fully defined. Hold alt to temporarily enable.`}
    >
      <FormControlLabel
        sx={{ ml: 1, mr: 1 }}
        label="Insert Automatically"
        control={
          <Switch
            checked={props.checked || altHeld}
            onChange={async (event) => {
              const checked = event.target.checked;

              props.onChange(checked);

              if (checked && props.canInsert) {
                await props.onInsert();
              }
            }}
          />
        }
      />
    </Tooltip>
  );
}
